import { styled } from '@linaria/react';

export const MSDSItem = styled.div`
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #17a2b8;
    margin-bottom: 1rem;

    p {
        margin: 0.75rem 0 0 0;
        color: #495057;
        line-height: 1.5;
    }
`;

export const MSDSInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    h4 {
        margin: 0;
        color: #333;
        font-size: 1rem;
        font-weight: 600;
    }

    span {
        color: #6c757d;
        font-size: 0.875rem;
    }
`;
